import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { CaptainDAO } from '../../../../../core/services/dao/captainDAO';
import { Captain } from 'anchor-shared/lib/model/entity/captain';
import { UserDAO } from '../../../../../core/services/dao/userDAO';
import { Router } from '@angular/router';

@Component({
  selector: 'app-description',
  templateUrl: './description.component.html',
  styleUrls: ['./description.component.scss'],
})
export class DescriptionComponent implements OnInit, OnDestroy {
  @Input() title: string;

  @Input() captain: Captain;

  @Input() newCaptain: boolean;

  @Input() adminAccess: boolean;

  @Output() onCancelled = new EventEmitter<boolean>();
  @Output() onSubmitted = new EventEmitter<any>();
  model: Captain;

  constructor(
    private captainDAO: CaptainDAO,
    private userDAO: UserDAO,
    private router: Router,
  ) {}

  ngOnInit() {
    const user = this.userDAO.getCurrentUser();
    this.model = user.captain;
  }

  ngOnDestroy(): void {}

  onSubmit() {
    console.log(this.model);
    if (!this.model.uscgLicensed) {
      this.model.uscgLicenseNumber = '';
    }
    this.onSubmitted.emit(this.model);
  }

  cancel() {
    console.log('cancel');
  }
}
